(function() {
    'use strict';

    function collectGeneralFormFieldValues(formId, doc) {
        const nameInput = doc.getElementById('name-' + formId);
        const emailInput = doc.getElementById('email-' + formId);
        const phoneInput = doc.getElementById('phone-' + formId);
        const subjectInput = doc.getElementById('subject-' + formId);
        const messageInput = doc.getElementById('message-' + formId);
        const fileInput = doc.getElementById('file-' + formId);
        const marketingConsentInput = doc.getElementById('marketing-consent-' + formId);
        const honeypotInput = doc.getElementById('website-' + formId);
        const formElement = doc.getElementById(formId + '-form');
        const sourceInput = formElement ? formElement.querySelector('input[name="Context.Source"]') : null;
        const pageUrlInput = formElement ? formElement.querySelector('input[name="Context.PageUrl"]') : null;
        const formPresetInput = formElement ? formElement.querySelector('input[name="Context.FormPreset"]') : null;
        const formNameInput = formElement ? formElement.querySelector('input[name="Context.FormName"]') : null;
        const crmRouteKeyInput = formElement ? formElement.querySelector('input[name="Context.CrmRouteKey"]') : null;
        const customFields = collectGeneralFormCustomFields(formElement);

        let topicValue = '';
        let topicCode = '';
        if (subjectInput) {
            if (subjectInput.tagName === 'SELECT') {
                const selectedOption = subjectInput.options[subjectInput.selectedIndex];
                topicCode = subjectInput.value || '';
                topicValue = subjectInput.value
                    ? (selectedOption ? selectedOption.text : subjectInput.value)
                    : '';
            } else {
                topicValue = subjectInput.value;
            }
        }

        return {
            name: nameInput ? nameInput.value : '',
            email: emailInput ? emailInput.value : '',
            phone: phoneInput ? phoneInput.value : undefined,
            topic: topicValue,
            topicCode: topicCode,
            message: messageInput ? messageInput.value : undefined,
            fileInput: fileInput || null,
            marketingConsent: !!(marketingConsentInput && marketingConsentInput.checked),
            honeypot: honeypotInput ? honeypotInput.value : '',
            source: sourceInput ? sourceInput.value : '',
            pageUrl: pageUrlInput ? pageUrlInput.value : '',
            formPreset: formPresetInput ? formPresetInput.value : '',
            formName: formNameInput ? formNameInput.value : '',
            crmRouteKey: crmRouteKeyInput ? crmRouteKeyInput.value : '',
            customFields: customFields
        };
    }

    function collectGeneralFormCustomFields(formElement) {
        if (!formElement) {
            return {};
        }

        const result = {};
        const namedCustomFields = formElement.querySelectorAll('[name^="CustomFields["]');
        namedCustomFields.forEach((element) => {
            const match = element.name.match(/^CustomFields\[(.+)\]$/);
            if (!match || !match[1]) {
                return;
            }

            const key = match[1].trim();
            const value = readFormElementValue(element);
            if (!key || !value) {
                return;
            }

            result[key] = value;
        });

        const attrCustomFields = formElement.querySelectorAll('[data-custom-field-key]');
        attrCustomFields.forEach((element) => {
            const key = (element.getAttribute('data-custom-field-key') || '').trim();
            if (!key || result[key]) {
                return;
            }

            const value = readFormElementValue(element);
            if (!value) {
                return;
            }

            result[key] = value;
        });

        return result;
    }

    function readFormElementValue(element) {
        if (!element) {
            return '';
        }

        if (element.type === 'checkbox') {
            return element.checked ? 'true' : '';
        }

        if (element.tagName === 'SELECT') {
            const option = element.options[element.selectedIndex];
            return option && option.value ? option.text.trim() : '';
        }

        return (element.value || '').trim();
    }

    function parseGeneralContactValue(rawContact) {
        const normalized = (rawContact || '').trim();
        if (!normalized) {
            return {
                email: '',
                phone: undefined
            };
        }

        const looksLikeEmail = normalized.includes('@');
        return {
            email: looksLikeEmail ? normalized : '',
            phone: looksLikeEmail ? undefined : normalized
        };
    }

    function buildGeneralFeedbackRequestData(values, consentChecked, pageUrl) {
        const normalizedTopic = (values.topic || '').trim();
        const normalizedEmail = (values.email || '').trim();
        const normalizedPhone = (values.phone || '').trim();
        const normalizedContact = parseGeneralContactValue(normalizedEmail);

        return {
            name: values.name || '',
            email: normalizedEmail || normalizedContact.email || undefined,
            phone: normalizedPhone || normalizedContact.phone || undefined,
            topic: normalizedTopic || 'Обращение с сайта',
            topicCode: values.topicCode || '',
            message: values.message,
            pdConsent: !!consentChecked,
            marketingConsent: !!values.marketingConsent,
            consentScope: 'feedback_form',
            pageUrl: values.pageUrl || pageUrl || '',
            honeypot: values.honeypot || '',
            source: values.source || '',
            formPreset: values.formPreset || '',
            formName: values.formName || '',
            crmRouteKey: values.crmRouteKey || '',
            customFields: values.customFields || {}
        };
    }

    function buildGeneralFeedbackFormData(requestData, fileInput) {
        const formData = new FormData();
        Object.keys(requestData).forEach((key) => {
            const value = requestData[key];
            if (value === undefined || value === null) {
                return;
            }

            if (key === 'customFields' && typeof value === 'object') {
                Object.keys(value).forEach((fieldKey) => {
                    const fieldValue = value[fieldKey];
                    if (!fieldValue) {
                        return;
                    }

                    formData.append(`CustomFields[${fieldKey}]`, fieldValue);
                });
                return;
            }

            formData.append(key, value);
        });

        if (fileInput && fileInput.files && fileInput.files.length > 0) {
            formData.append('file', fileInput.files[0]);
        } else if (fileInput && fileInput._droppedFiles && fileInput._droppedFiles.length > 0) {
            formData.append('file', fileInput._droppedFiles[0]);
        }

        return formData;
    }

    function initGeneralForms() {
        const generalForms = document.querySelectorAll('.general-form form');
        generalForms.forEach((form) => {
            initGeneralForm(form);
        });
    }

    function initGeneralForm(form) {
        if (!form) {
            return;
        }

        if (form.dataset.generalFormInitialized === 'true') {
            return;
        }
        form.dataset.generalFormInitialized = 'true';

        const formContainer = form.closest('.general-form');
        const formId = formContainer ? formContainer.id : 'general-form';

        window.AjaxFormRuntime.bindSubmit(form, {
            formId: formId,
            collectValues: (fId, doc) => collectGeneralFormFieldValues(fId, doc),
            buildRequest: (vals, consentChecked, ctx) => buildGeneralFeedbackRequestData(vals, consentChecked, ctx.pageUrl),
            getFetchArgs: (requestData, vals, form) => {
                const hasFile = (vals.fileInput && vals.fileInput.files && vals.fileInput.files.length > 0) ||
                                (vals.fileInput && vals.fileInput._droppedFiles && vals.fileInput._droppedFiles.length > 0);

                if (hasFile) {
                    const formData = buildGeneralFeedbackFormData(requestData, vals.fileInput);
                    return [
                        '/api/lead/feedback-with-file',
                        {
                            method: 'POST',
                            headers: {},
                            body: formData
                        }
                    ];
                } else {
                    return [
                        '/api/lead/feedback',
                        {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(requestData)
                        }
                    ];
                }
            },
            onSuccess: (form, result) => {
                if (window.gtag) {
                    window.gtag('event', 'form_submit', {
                        event_category: 'form',
                        event_label: 'general',
                        form_id: formId
                    });
                }
            }
        });
    }

    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initGeneralForms);
        } else {
            initGeneralForms();
        }

        if (typeof window !== 'undefined') {
            window.initGeneralForms = initGeneralForms;
        }
    }

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = {
            collectGeneralFormFieldValues,
            buildGeneralFeedbackRequestData,
            buildGeneralFeedbackFormData,
            initGeneralForms
        };
    }
})();
